import { useEffect, useRef, useState } from 'react'

export const useModalAwareIntersectionObserver = ({ threshold = 0 }, isModalOpen = false) => {
  const elementRef = useRef(null)
  const [isIntersecting, setIsIntersecting] = useState(true)
  const [stableIsIntersecting, setStableIsIntersecting] = useState(true)

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
      },
      { threshold }
    )

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [threshold])

  useEffect(() => {
    if (!isModalOpen) {
      setStableIsIntersecting(isIntersecting)
    }
  }, [isIntersecting, isModalOpen])

  return [elementRef, stableIsIntersecting]
}
